import React, { useMemo } from "react"
import PropTypes from 'prop-types'

import { File } from "react-feather"

const PdfResponse = ({ data, widgetStyle }) => {
  const { title, url } = useMemo(() => {
    if (data instanceof Array) {
      return data?.[0] || {}
    }
    return data || {}
  }, [data])

  const {
    secondaryBGC,
    secondaryTextColor,
    botIcon
  } = useMemo(() => widgetStyle, [widgetStyle])

  return (
    <div className="bot-response">
      <div className="invisible">
        <img src={botIcon} className="bot-profile-photo" alt="elie" />
      </div>

      <div className="d-flex" id="pdf-response" style={{ background: secondaryBGC }}>
        <div className="pdf-icon-div">
          <File size={12} color={secondaryTextColor} />
        </div>
        <div className="pdf-link-div" style={{ background: secondaryTextColor }}>
          <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: secondaryBGC }} dangerouslySetInnerHTML={{ __html: title || "PDF Document" }}>
            {/* {title || "PDF Document"} */}
          </a>
        </div>
      </div>
    </div>
  )
}

PdfResponse.propTypes = {
  data: PropTypes.any,
  widgetStyle: PropTypes.any
}

export default PdfResponse
